export { getStoresServerAction } from 'next-flight-server-reference-proxy-loader?id=706a0a5587948484f9bb1adaa19dbd62166328b954&name=getStoresServerAction!'